import { imagePreview } from "../../components/imagePreview/main";

document.addEventListener("DOMContentLoaded", () => {
	const previewImgs = document.querySelectorAll(
		".preview-img",
	) as NodeListOf<HTMLImageElement>;

	if (previewImgs.length === 0) return;

	const urls: string[] = [];
	previewImgs.forEach((img) => {
		const src = img.getAttribute("data-preview-src") || img.src;
		urls.push(src);
	});

	previewImgs.forEach((img, index) => {
		img.addEventListener("click", (e) => {
			e.preventDefault();
			imagePreview({
				urls,
				index,
			});
		});
	});
});
